import React from "react";
import { CompanyTitledPage } from "../../TitledPage";
import PurchaseTransferTable from "./PurchaseTransferTable";
import useSalesPurchaseTransferPageInfo from "./hooks/useSalesPurchaseTransferPageInfo";
import SalesPurchaseTransferTotalDateForm from "./SalesPurchaseTransferTotalDateForm";
import SalesTransferTable from "./SalesTransferTable";
import { Divider, Grid } from "@mui/material";
import PurchaseTransferBreakdownTable from "./PurchaseTransferBreakdownTable";
import TransferTotalTable from "./TransferTotalTable";
import SalesTransferBreakdownTable from "./SalesTransferBreakdownTable";

export default function SalesPurchaseTransferPage() {

  const {salesPurchaseTransferInfo, totalDate, changeTotalDate} = useSalesPurchaseTransferPageInfo();

  return (
    <CompanyTitledPage title="仕入売上振替確認" hideCurrentTime>
      <Grid container mb={2}>
        <Grid item xs mr={2}>
          <TransferTotalTable
            salesPurchaseTransferInfo={salesPurchaseTransferInfo}
          />
        </Grid>
        <Grid item xs>
          <SalesPurchaseTransferTotalDateForm
            totalDate={totalDate}
            changeTotalDate={changeTotalDate}
          />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs mr={2}>
          <PurchaseTransferTable
            purchaseTransferInfo={salesPurchaseTransferInfo.purchaseTransferInfo}
          />
        </Grid>
        <Grid item xs>
          <SalesTransferTable
            salesTransferInfo={salesPurchaseTransferInfo.salesTransferInfo}
          />
        </Grid>
      </Grid>

      <Divider variant="middle" sx={{marginY: 3, border: "1px gray solid"}} />

      <Grid container>
        <Grid item xs mr={2}>
          <PurchaseTransferBreakdownTable
            purchaseTransferBreakdownInfo={salesPurchaseTransferInfo.purchaseTransferBreakdownInfo}
          />
        </Grid>
        <Grid item xs>
          <SalesTransferBreakdownTable
            salesTransferBreakdownInfo={salesPurchaseTransferInfo.salesTransferBreakdownInfo}
          />
        </Grid>
      </Grid>
    </CompanyTitledPage>
  );
}
